//? Componente que contiene el modal para cerrar un reclamo
<template>
    <div class="pdr">
        <ul v-if="!datos.envio">
          <li>Retira en <strong>{{datos.name.toLowerCase()}}</strong></li>
          <li>
            <span>
             {{datos.street.toLowerCase()}} {{datos.number}} - {{datos.state}} - CP:{{datos.postalCode}}
            </span>

             </li>
             <li>
               {{datos.instructions.toLowerCase()}}
             </li>
        </ul>
         <ul v-if="datos.envio">
          <li> <strong style="text-transform:none">Envío a domicilio</strong></li>
          <li>
            <span>
             {{datos.envio_domicilio.direccion}} - {{datos.envio_domicilio.direccion2}} - {{datos.envio_domicilio.ciudad}} ({{datos.envio_domicilio.codpos}}) - {{datos.envio_domicilio.provincia}}
            </span>

             </li>
             <li>
               Recibe: <strong>{{datos.envio_domicilio.nomb_recibe}}</strong> 
             </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props:['datos'],
        name:"puntoretiro",
        data() {
            return {
              latitude      : '',
              longitude     : '',
              ptoRetiro     : '',
              street        : '',
              number        : '',
              state         : '',
              postalCode    : '',
              instructions  : '',
              urlGoogleMaps : `https://maps.google.com/?q= ${this.datos.latitude} , ${this.datos.longitude}`,
              vtexId        : '',
              ciudad        : '',
              id: '',
              direccion: '',
              metodo: '',
              provincia: ''
            }
        },
       
        methods:{
            PuntoRetiro() {
              // console.log('pto retiro',this.datos);
              if(this.datos && this.datos.envio) {
                this.metodo = 'ENVIÓ A DOMICILIO'
                // console.log('entrooo');
                const { latitude, longitude, ciudad, codpos, direccion, id, nomb_recibe, provincia, vtex_order_id } = this.datos.envio_domicilio

                      this.latitude     = latitude ? latitude :''
                      this.longitude    = longitude
                      this.ptoRetiro    = direccion.toUpperCase()
                      this.id           = id
                      this.ciudad       = ciudad
                      this.provincia    = provincia
                      this.postalCode   = codpos

                      this.instructions = `ENTREGAR A: ${nomb_recibe}`
                      
                      this.urlGoogleMaps=  `https://maps.google.com/?q= ${latitude} , ${longitude}`
                      this.vtexId = vtex_order_id

                      this.direccion = `${ ciudad } - CP${codpos}`

                      
              } else {
                // console.log('datos pto retiro', this.datos)
                this.metodo = 'RETIRA DE FARMACIA' 

                const { latitude, longitude, name, street, number, state, postalCode, instructions, } = this.datos

                      this.latitude     = latitude ? latitude : ''
                      this.longitude    = longitude
                      this.ptoRetiro    = name
                      this.instructions = instructions
                      this.urlGoogleMaps=  `https://maps.google.com/?q= ${latitude} , ${longitude}`

                      this.direccion = `${street.toUpperCase()} ${number} - ${state.toUpperCase()} (${postalCode})`
              }
              
            }
        }
    }
</script>

<style lang="scss" scoped>
 .pdr ul {
   list-style: none;
   padding: 0;
   margin: 0;
   text-align: left;
   font-size: 13.5px;
 }
 .pdr strong, .pdr span {
   text-transform: capitalize;
 }
</style>